module.exports = __webpack_public_path__ + "img/plus.e8783211.svg";